import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT, LoadContactsResponse } from '@ld.consumer-portal/models';
import { firstValueFrom } from 'rxjs';
import { LoggingService } from '@ld.consumer-portal/utils';

@Injectable({
  providedIn: 'root',
})
export class OriginationContactsService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);
  private readonly loggingService = inject(LoggingService);

  private get cpApiUrl(): string {
    return this.env.appSettings.cpApiUrl || '';
  }

  private get apiNamespace(): string {
    return this.env.appSettings.apiNamespace || 'api/v1';
  }

  async loadContacts(loanId: string): Promise<LoadContactsResponse> {
    const url = `${this.cpApiUrl}/${this.apiNamespace}/loans/${loanId}/contacts`;

    try {
      return await firstValueFrom(this.http.get<LoadContactsResponse>(url));
    } catch (error: unknown) {
      this.loggingService.logException(error, `Error loading contacts for loan ${loanId}`);
      throw new Error(`Failed to load contacts: ${error instanceof Error ? error.message : String(error)}`);
    }
  }
}
